module.exports = __webpack_public_path__ + "img/cover27.59310f8f.png";